<template>
  <div
    class="user-login"
    :style="`background-image: url(${bgcImgUrl})`"
  >
    <div class="goLogin">
      <!-- <div
        class="left"
        v-if="currentShow === 1 || currentShow === 4"
      >
        <h3>{{ $t('register.noAccount') }}</h3>
        <router-link
          to="/register"
          tag="p"
        >
          {{ $t('register.signUpNow') }}
        </router-link>
      </div> -->
      <div
        class="left"
        v-if="currentShow === 2 || currentShow === 3"
      >
        <h3>{{ $t('register.relogin') }}</h3>
        <p @click="goBackLogin">
          {{ $t('register.gologin') }}
        </p>
      </div>
      <div class="right">
        <!-- 账号密码登录 -->
        <el-form
          v-if="currentShow === 1"
          key=currentShow1
          :hide-required-asterisk="true"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
        >
          <img
            :src="loginLogoUrl"
            alt="logo"
          >
          <el-form-item
            :label="$t('register.account')"
            prop="usernum"
          >
            <el-input
              @keyup.native.13="submitForm('ruleForm')"
              v-model="ruleForm.usernum"
              maxlength="16"
              :placeholder="$t('rules.enterAcc')"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('register.psw')"
            prop="userpassword"
          >
            <el-input
              @keyup.native.13="submitForm('ruleForm')"
              type="password"
              v-model="ruleForm.userpassword"
              maxlength="16"
              :placeholder="$t('register.psw1')"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!-- <ul class="langChange">
            <li @click="changeLange(item, index)" v-for="(item, index) in langArr" :key="item.id" :class="{isChangeLang:isActiveLength == index}">{{item.name}}</li>
          </ul> -->

          <div class="forget"><span @click="goForget">{{ $t('global.forget') }}</span></div>

          <el-form-item>
            <el-button
              class="theButton"
              :display="more"
              :class="{ disabled: ruleForm.usernum.length < 4 || ruleForm.userpassword.length < 6 }"
              type="primary"
              @click="submitForm('ruleForm')"
            >{{ $t('register.login') }}</el-button>
          </el-form-item>
        </el-form>

        <!-- （第一次登录/找回密码时）修改密码 -->
        <el-form
          v-if="currentShow === 2"
          key="currentShow2"
          :model="ruleForm1"
          :rules="rules"
          ref="ruleForm1"
          label-width="150px"
        >
          <img
            :src="loginLogoUrl"
            alt="logo"
          >
          <div class="logoText">{{ $t('form.changePass') }}</div>
          <el-form-item
            :label="$t('register.newPassword')"
            prop="newPassword"
          >
            <el-input
              @keyup.native.13="submitForm1('ruleForm')"
              type="password"
              v-model="ruleForm1.newPassword"
              maxlength="16"
              :placeholder="$t('register.newPsw')"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('register.surePassword')"
            prop="surePassword"
          >
            <el-input
              @keyup.native.13="submitForm1('ruleForm')"
              type="password"
              v-model="ruleForm1.surePassword"
              maxlength="16"
              :placeholder="$t('register.checkTwice')"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <ul class="langChange">
            <!-- <li @click="changeLange(item, index)" v-for="(item, index) in langArr" :key="item.id" :class="{isChangeLang:isActiveLength == index}">{{item.name}}</li> -->
          </ul>

          <el-form-item>
            <el-button
              class="theButton"
              :display="more"
              :class="{ disabled: ruleForm.usernum.length < 4 || ruleForm.userpassword.length < 6 }"
              type="primary"
              @click="submitForm1('ruleForm1')"
            >{{ $t('global.complete') }}</el-button>
          </el-form-item>
        </el-form>

        <!-- 找回密码表单 -->
        <el-form
          v-if="currentShow === 3"
          key="currentShow3"
          :model="ruleForm2"
          :rules="rules"
          ref="ruleForm2"
          label-width="150px"
        >
          <img
            :src="loginLogoUrl"
            alt="logo"
          >
          <div class="logoText">{{ $t('form.certify') }}</div>
          <el-form-item
            :label="$t('form.phoneNumber')"
            prop="phoneNum"
          >
            <el-input
              @keyup.native.13="getCode"
              v-model="ruleForm2.phoneNum"
              maxlength="11"
              :placeholder="$t('form.phone1')"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('homepage.code')"
            prop="code"
          >
            <el-input
              @keyup.native.13="checkCode"
              v-model="ruleForm2.code"
              maxlength="6"
              :placeholder="$t('form.codeEmpty')"
              autocomplete="off"
            >
              <el-button
                class="appendBtn"
                @click="getCode"
                :disabled="typeof(appendText)==='number'"
                slot="append"
                type="text"
              >{{appendText}}</el-button>
            </el-input>
          </el-form-item>

          <el-button
            class="certifyBtn"
            type="primary"
            @click="checkCode"
          >{{ $t('homepage.yes') }}</el-button>

        </el-form>

        <!-- 选择身份 -->
        <section v-else-if="currentShow === 4">
          <img
            class="logo"
            :src="loginLogoUrl"
            alt="logo"
          >
          <div class="please-choose">{{ $t('global.pleaseChoose') }}</div>

          <div class="option">
            <div
              class="option-item"
              :class="{active: item.id===activeIdentity}"
              v-for="(item,index) in identityOption"
              :key="index"
              @click="changeIdentity(item.id)"
            >
              <div class="option-img">
                <img
                  :src="item.img"
                  alt="user"
                >
                <div class="option-text">{{item.text}}</div>
              </div>
            </div>
          </div>
          <div class="choose-btn">
            <el-button
              class="certifyBtn"
              type="primary"
              @click="chooseIdentity"
            >{{ $t('register.login') }}</el-button>
          </div>

        </section>

      </div>
    </div>
  </div>
</template>

<script>
// import './assets/css/theme/409EFF/index.css';
import "../../assets/css/theme/E62125/index.css";
import store from "../../store/index.js";
export default {
  data() {
    let checkAccount = (rule, value, callback) => {
      const reg = /^[\w]{4,16}$/;
      if (value === "") {
        callback(new Error(this.$t("register.accountEmpty")));
      } else if (!reg.test(value)) {
        callback(new Error(this.$t("rules.account")));
      } else {
        callback();
      }
    };

    let validatePass = (rule, value, callback) => {
      // const reg = /^[^[\u4e00-\u9fa5]{6,16}]*$/;
      if (value === "") {
        callback(new Error(this.$t("register.pswEmpty")));
      }
      // else if (!reg.test(value)) {
      // 	callback(new Error(this.$t('register.pswtip')));
      // }
      else {
        callback();
      }
    };

    let validateNewPass = (rule, value, callback) => {
      if (value !== this.ruleForm1.newPassword) {
        callback(new Error(this.$t("register.noSame")));
      } else {
        callback();
      }
    };

    let validatePhoneNum = (rule, value, callback) => {
      let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      if (value === "") {
        return callback(new Error(this.$t("form.phone2")));
      }
      if (!reg.test(value)) {
        return callback(new Error(this.$t("form.phoneNumErr")));
      }
      return;
    };
    let validateCode = (rule, value, callback) => {
      if (value === "") return callback(new Error(this.$t("form.codeEmpty")));
      return;
    };
    return {
      change_pass_code: "",
      appendText: this.$t("form.getCode"),
      currentShow: 1, // 1表示登录相关表单； 2表示修改密码相关表单；  3表示找回密码相关表单；   4选择身份部分
      isTencentCloud: sessionStorage.getItem("tencentCloud"), // 是否为腾讯云平台
      logo_url: "", //logo地址
      bgcImgUrl: "", //背景图地址
      loginLogoUrl: "", //登录输入框的logo地址
      more: false, // 点击登录后在没有请求返回信息时都为true，防止多次点击登录事件

      rules: {
        usernum: [{ validator: checkAccount, trigger: "blur" }],
        userpassword: [{ validator: validatePass, trigger: "blur" }],
        newPassword: [
          {
            required: true,
            pattern: this.rules.strongPwd.reg,
            trigger: "blur",
            message: this.$t("rules.strongPwd"),
          },
        ],
        surePassword: [
          { required: true, validator: validateNewPass, trigger: "blur" },
        ],
        phoneNum: [
          { required: true, validator: validatePhoneNum, trigger: "blur" },
        ],
        code: [{ required: true, validator: validateCode, trigger: "blur" }],
      },

      ruleForm: {
        usernum: "",
        userpassword: "",
      },

      ruleForm1: {
        newPassword: "",
        surePassword: "",
      },

      ruleForm2: {
        phoneNum: "",
        code: "",
      },

      activeIdentity: 1, // 1为普通用户； 2为战略客户
      identityOption: [
        {
          id: 1,
          img: require("@/assets/images/customer/option1.png"),
          text: "内部员工",
        },
        {
          id: 2,
          img: require("@/assets/images/customer/option2.png"),
          text: "战略客户",
        },
      ],

      langArr: [
        { id: 1, name: "简体中文", lang: "zh-cn" },
        { id: 2, name: "繁體中文", lang: "zh-hk" },
        { id: 3, name: "ENGLISH", lang: "en-us" },
      ],
      langStr: ["zh-cn", "zh-hk", "en-us"],
      isActiveLength: 0,
      jumpPage: "",
    };
  },
  created() {
    this.getAccessToken();
    window.addEventListener("storage", this.changeStorage);
  },
  mounted() {
    this.getDefaulteLang();
    this.toggleClass(document.body, "custom-E62125");
    this.getHomeHeaderMenu();
  },
  beforeDestroy() {
    this.toggleClass(document.body, "custom-409EFF");
    window.addEventListener("storage", this.changeStorage);
  },
  methods: {
    changeStorage() {
      if (!localStorage.getItem("access_token")) {
        sessionStorage.setItem("decisionPlatform", 'logintable');
        localStorage.setItem("lang", 'zh-cn');
        this.getAccessToken('clear');
      }
    },
    chooseIdentity() {
      if (this.activeIdentity === 1) {
        //  普通用户跳转首页
        // window.location.href = window.location.origin + this.jumpPage;

       this.$router.push(this.jumpPage)
      } else if (this.activeIdentity === 2) {
        //  战略客户跳转首页
        // window.location.href = window.location.origin + "/customer-home";
       this.$router.push('/customer-home')
      }
    },
    changeIdentity(id) {
      this.activeIdentity = id;
    },
    checkUserExist() {
      let success = (res) => {
        if (res.code === 200) {
          this.appendText = 60;
          this.getCodeApi();
          let timer = setInterval(() => {
            if (this.appendText > 1) this.appendText--;
            else {
              this.appendText = this.$t("form.reGetCode");
              clearInterval(timer);
            }
          }, 1000);
        }
      };
      let params = {
        num: this.ruleForm2.phoneNum,
        type: 1,
      };
      this.$ajax.get("/api/login/get_user", {
        params,
        func: {
          success,
        },
      });
    },
    checkCode() {
      let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      if (this.ruleForm2.phoneNum === "")
        return this.$message.error(this.$t("form.phone2"));
      if (!reg.test(this.ruleForm2.phoneNum))
        return this.$message.error(this.$t("form.phoneNumErr"));
      if (this.ruleForm2.code === "")
        return this.$message.error(this.$t("form.codeEmpty"));
      let params = {
        phone: this.ruleForm2.phoneNum,
        code: this.ruleForm2.code,
      };
      let success = (res) => {
        this.$message.success(this.$t("form.certifySuc"));
        this.$g.user_id = res.data.user_id;
        this.change_pass_code = res.data.change_pass_code;

        this.ruleForm2 = {
          phoneNum: "",
          code: "",
        };

        this.currentShow = 2;
      };
      this.$ajax.get("/api/login/check_code_changefirst", {
        params,
        func: {
          success,
        },
      });
    },
    getCodeApi() {
      let params = {
        phone: this.ruleForm2.phoneNum,
        ismailphone: 1,
      };
      let success = (res) => {
        if (res.code === 200) {
          // console.log(res)
          this.$message.success(this.$t("form.getCodeSuc"));
        } else {
          // console.log("success", res);
          this.$message.error(res.msg);
        }
      };
      let fail = (err) => {
        console.log("fail", err);
        this.$message.error(err.msg);
      };
      this.$ajax.post("/api/login/send_phone_mail", params, {
        func: { success, fail },
      });
    },
    getCode() {
      let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      if (this.ruleForm2.phoneNum === "")
        return this.$message.error(this.$t("form.phone2"));
      if (!reg.test(this.ruleForm2.phoneNum))
        return this.$message.error(this.$t("form.phoneNumErr"));

      this.checkUserExist();
    },
    goForget() {
      this.currentShow = 3;
    },
    goBackLogin() {
      localStorage.setItem("token", "");
      sessionStorage.setItem("user_info_str", "");
      this.change_pass_code = "";
      this.currentShow = 1;
    },
    changeFirstLoginApi() {
      let params = {
        user_id: this.$g.user_id,
      };
      let success = (res) => {
        // console.log('取消首次登录标志以后提示用户重新登录', res)
        this.$message.success(this.$t("register.changeSuccess"));
        this.ruleForm.userpassword = "";
        // 取消首次登录标志以后提示用户重新登录
        this.currentShow = 1;
      };
      let fail = (error) => {
        console.log("changeFirstLoginApi Error", error);
      };
      this.$ajax.put("api/login/changefirstlogin", params, {
        func: {
          success,
          fail,
        },
      });
    },
    checkCodeChangePasswordApi() {
      let params = {
        user_id: this.$g.user_id,
        newPass1: this.ruleForm1.surePassword,
        change_pass_code: this.change_pass_code,
      };
      let success = (res) => {
        if (res.code === 200) {
          // 修改密码成功后
          this.$message.success(this.$t("register.changeSuccess"));
          this.change_pass_code = "";
          this.ruleForm.userpassword = "";
          this.currentShow = 1;
        } else {
          // 修改失败
          this.$message.error(res.msg);
        }
      };
      let fail = (res) => {
        // console.log(res);
        this.$message.error(res.msg);
      };
      this.$ajax.put("api/login/check_code_changefirst", params, {
        func: {
          success,
          fail,
        },
      });
    },
    changePasswordApi() {
      let params = {
        user_id: this.$g.user_id,
        is_first: 1,
        // nowPass: this.ruleForm.userpassword,
        newPass1: this.ruleForm1.surePassword,
      };
      let fail = (error) => {
        console.log("changePasswordApi Error", error);
        this.$message.error(error.msg);
      };
      let success = (res) => {
        // console.log('修改密碼成功后取消首次登录标志', res)
        // 成功后取消首次登录标志
        this.changeFirstLoginApi();
      };
      this.$ajax.put("api/login/changepass", params, {
        func: {
          success,
          fail,
        },
      });
    },

    getDefaulteLang() {
      setTimeout(() => {
        this.isActiveLength = this.langStr.indexOf(this.$i18n.locale);
      }, 1000);
    },

    getAccessToken( type ) {
      let self = this;
      self.$ajax
        .get("/accessToken", {
          params: {
            company: "BL",
            device_name: "TE-0600R",
            data: {
              client_id: "20882088",
              secret: "nGk5R2wrnZqQ02bed29rjzax1QWRIu1O",
            },
          },
        })
        .then((response) => {
          localStorage.setItem("access_token", response.data.data.access_token);
          if(type) {return }
          self.getLogo();
          self.getBackgroudPic();
          // this.getUseInfo('check');
        });
    },
    //获取logo
    getLogo() {
      let success = (res) => {
        this.logo_url = res.data[0].f_logo;
      };
      this.$ajax({
        url: "api/system/get_logo",
        method: "get",
        params: {},
        func: { success: success },
      });
    },
    getHomeHeaderMenu() {
      let success = (res) => {
        if (res.data[0].url == "/") {
          res.data[0].url = "/homeindex";
        }
        this.jumpPage = res.data[0].url;
      };
      this.$ajax({
        url: "api/system/get_home_menu_cansee",
        method: "get",
        params: {},
        func: { success: success },
      });
    },

    //获取背景图
    getBackgroudPic() {
      let success = (res) => {
        this.bgcImgUrl = this.BASE_URL + res.data.back_image;
        this.loginLogoUrl = this.BASE_URL + res.data.logo_image;
      };
      this.$ajax({
        url: "api/system/login_set",
        method: "get",
        params: {},
        func: { success: success },
      });
    },
    submitForm1(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.change_pass_code) {
            this.checkCodeChangePasswordApi();
          } else {
            this.changePasswordApi();
          }
        } else this.more = false;
      });
    },
    submitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (!window.navigator.onLine) {
            this.$message.error(this.$t("homepage.connect"));
            return;
          }
          this.more = true;
          let success = (res) => {
            // this.$message.success(res.msg);
            localStorage.setItem("token", res.data);
            this.getUseInfo();
          };
          let fail = (err) => {
            this.$message.error(err.msg);
            this.more = false;
          };
          let params = {
            usernum: this.ruleForm.usernum,
            userpassword: this.ruleForm.userpassword,
          };

          this.$ajax.post("api/login/login", params, {
            func: { success, fail },
          });
        } else {
          this.more = false;
        }
      });
    },

    /**
     * 获取用户信息
     */
    getUseInfo() {

      const success = (res) => {
        let data = res.data;
        // 缓存获取到的用户信息
        sessionStorage.setItem("user_info_str", JSON.stringify(data.userinfo));
        sessionStorage.setItem("manage", JSON.stringify(data.manage));
        sessionStorage.setItem("manage_url", data.manage_url);
        sessionStorage.setItem("ItcJwtToken", data.userinfo.ItcJwtToken);
        localStorage.setItem("userType", data.userinfo.type);
        store.commit("SET_USERINFO", data.userinfo);
        this.$g.user_id = data.userinfo.id;
        // 看看是否是商学院
        // if (this.isTencentCloud == 1) {
        // 如果是商学院的话--->如果是首次登录账号，那么进行修改密码
        if (data.userinfo.first_login === 1) {
          // 展示修改密码表单
          this.currentShow = 2;
          return;
        } else {
          if (data.userinfo.type === 1 && data.userinfo.use_customer === 1) {
            this.currentShow = 4;
          } else if (data.userinfo.type === 2) {
            this.$message.success(res.msg);
            setTimeout(() => {
              // this.$router.replace({ path: "/customer-home" });
              this.$router.push('/customer-home')
            }, 500);
          } else if (
            data.userinfo.type === 1 &&
            data.userinfo.use_customer === 0
          ) {
            this.$message.success(res.msg);
            setTimeout(() => {
              //默认跳转header_menu的第一个页面
              window.location.href = window.location.origin + this.jumpPage;
            }, 500);
          } else {
            this.$message.success(res.msg);
            setTimeout(() => {
              //默认跳转header_menu的第一个页面
              window.location.href = window.location.origin + this.jumpPage;
            }, 500);
          }
        }
        return;
        // } else {
        //   if (checkLogin) {
        //     //默认跳转header_menu的第一个页面
        //     window.locatin.href = window.location.origin + this.jumpPage;
        //     return;
        //   }
        //   // 不是商学院，直接跳转
        //   setTimeout(() => {
        //     //默认跳转header_menu的第一个页面
        //     window.location.href = window.location.origin + this.jumpPage;
        //   }, 500);
        //   return;
        // }
      };

      const fail = (err) => {};

      this.$ajax.get("api/login/new_login", {
        func: { success: success, fail: fail },
      });
    },

    changeLange(item, index) {
      this.isActiveLength = index;
      const success = (res) => {
        this.$i18n.locale = item.lang;
      };

      this.$ajax.get("api/login/change_lang", {
        params: { default_lang: item.lang },
        func: { success },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.logoText {
  text-align: center;
  background-color: #fff;
  position: relative;
  top: -40px;
  height: 20px;
  letter-spacing: 4px;
  font-size: 18px;
  font-weight: 800;
}
.certifyBtn {
  margin-top: 4rem;
  background-color: #e62125;
  color: #fff;
  width: 100%;
}
.forget {
  height: 3rem;
  line-height: 3rem;
  color: #e62125;
  text-align: right;
  & > span:hover {
    cursor: pointer;
    opacity: 0.7;
  }
}
:deep(.el-input-group__append ){
  background-color: rgba(255, 255, 255, 0);
  border: none;
  border-bottom: 1px solid #c5c5c5;
  color: #e62125;
  &:hover {
    color: #e62125;
    opacity: 0.7;
  }
}
.user-login {
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-width: 1152px;
  min-height: 880px;
  background-position: 38% top;
    background-repeat: no-repeat;
    background-size: cover;

  .goLogin {
    height: 410px;
    width: 1100px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(255, 255, 255, 0.2) 100%
    );
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;

    .left {
      width: 410px;
      height: 100%;
      float: left;
      color: #fff;
      font-family: MicrosoftYaHei;
      padding-left: 90px;

      h3 {
        font-size: 32px;
        line-height: 42px;
        margin: 110px 0 34px 0;
      }

      p {
        height: 47px;
        width: 185px;
        line-height: 47px;
        font-size: 22px;
        border: 2px solid #fff;
        text-align: center;
        cursor: pointer;
      }
    }

    .right {
      height: 540px;
      width: 480px;
      background-color: #fff;
      position: absolute;
      left: 310px;
      top: -60px;
      padding: 62px 65px;
      box-sizing: border-box;

      .el-form {
        height: 100%;

        > img {
          display: block;
          padding-bottom: 20px;
          margin: auto;
          height: 86px;
        }

        .el-form-item {
          margin: 0;

          :deep(.el-form-item__label ){
            padding-top: 22px;
            display: block;
            text-align: left;
            float: none;
            font-size: 12px;
            color: #333333;
            line-height: 32px;
          }

          :deep(.el-form-item__content ){
            margin: 0 !important;
            line-height: 36px;

            .el-input__inner {
              padding: 0;
              border: 0 none;
              height: 36px;
              border-bottom: 1px solid #c5c5c5;
              color: #000;

              &::-webkit-input-placeholder {
                color: #888888;
              }
            }
          }
        }

        .langChange {
          margin-top: 30px;
          height: 25px;
          display: flex;
          justify-content: center;

          li {
            width: 80px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            border: 2px solid #fff;
            border-radius: 3px;
            cursor: pointer;
          }

          li + li {
            margin-left: 1px;
          }

          .isChangeLang {
            background-color: #888;
            color: #fff;
            border: 2px solid #888;
          }
        }

        .theButton {
          width: 350px;
          margin-top: 30px;
          background-color: #e62125;
          border-color: #e62125;
        }
      }

      section {
        > img {
          display: block;
          padding-bottom: 20px;
          margin: auto;
          height: 86px;
        }
        .please-choose {
          padding: 5px 20px;
          text-align: left;
          font-size: 1.6rem;
          font-weight: 700;
        }
        .option {
          display: flex;
          justify-content: space-between;
          padding: 20px;
          user-select: none;

          .option-item {
            width: 140px;
            height: 140px;
            background-color: #eaf0f8;
            border-radius: 8px;
            position: relative;
            border: 2px solid #fff;
            .option-text {
              text-align: center;
              margin-top: -3rem;
              font-size: 1.5rem;
            }
            &:hover {
              cursor: pointer;
              opacity: 0.8;
            }
          }
          .active {
            border: 2px solid #4477C3;
            color: #4477C3;
          }
        }
        .choose-btn {
          padding: 0 25px;
        }
      }
    }
  }
}
</style>
